<template>
    <div>
        <h4 class="title is-5 s-b-margin">{{ formatUnitName(notification.unit) }}</h4>

        <div class="tags no-b-margin">
            <span class="tag prefix-tag">{{ $t("misc.mailtoHeader") }}</span>
            <span class="tag" v-for="(email, index) in this.notification.emails" :key="index">
                {{ email }}
            </span>
        </div>

        <b-field :label="$t('misc.triggerInKm')" class="s-b-padding">
            <b-input v-model="notificationTrigger" class="full-width" type="number" max="500" min="0"
                :placeholder="$t('notifications.triggerPlaceholder')"></b-input>
            <p class="control">
                <b-button class="button is-primary"
                    @click="$emit('add-notification', notification, notificationTrigger)">
                    {{ $t("misc.add") }}
                </b-button>
            </p>
        </b-field>

        <hr />
    </div>
</template>

<script>

import { formatUnitName } from "@/utils/format";

export default {
    name: "CreateNotificationRow",
    props: {
        notification: Object
    },
    data: function () {
        return {
            notificationTrigger: null
        }
    },
    methods: {
        formatUnitName: formatUnitName
    }
};

</script>

<style scoped>
.prefix-tag {
    padding: 0;
    background-color: transparent;
}
</style>